import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=24410843&scoped=true"
import script from "./WaitingList.vue?vue&type=script&lang=js"
export * from "./WaitingList.vue?vue&type=script&lang=js"
import style0 from "./WaitingList.vue?vue&type=style&index=0&id=24410843&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24410843",
  null
  
)

export default component.exports